import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { HighlightText } from '../HighlightText/HighlightText'

export const ResultContentListRow: React.FC<{
  primaryText: React.ReactNode
  searchTerm?: string
  secondaryText?: React.ReactNode
  testId?: string
  topContent?: React.ReactNode
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
}> = ({
  primaryText,
  secondaryText,
  testId,
  topContent,
  leftContent,
  rightContent,
  searchTerm,
}) => {
  return (
    <HighlightText text={searchTerm}>
      <WrapperStyled data-testid={testId} noFlex={!!searchTerm}>
        <div>{topContent}</div>

        <div>
          <span>{leftContent}</span>

          <span className='result-content__text'>
            <span>{primaryText}</span>
            <span>{secondaryText}</span>
          </span>

          <span>{rightContent}</span>
        </div>
      </WrapperStyled>
    </HighlightText>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div<{ noFlex: boolean }>(props => ({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx2,
  paddingBlock: spacing.smx1,

  '> div:nth-of-type(2)': {
    display: 'flex',
    gap: spacing.smx2,

    '.result-content__text': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      // Primary
      '> span:first-of-type': {
        fontSize: font.size.lg.fontSize,
        letterSpacing: font.size.lg.letterSpacing,
        lineHeight: font.size.lg.lineHeight,
        fontWeight: font.weight.medium,
        color: colors.black,
      },

      // Secondary
      '> span:last-of-type': {
        // the text highlighter doesnt work on flex
        display: props.noFlex ? undefined : 'flex',
        gap: props.noFlex ? undefined : spacing.smx2,
        fontSize: font.size.md.fontSize,
        letterSpacing: font.size.md.letterSpacing,
        lineHeight: font.size.md.lineHeight,
        fontWeight: font.weight.regular,
        color: colors.neutral[800],
      },
    },
  },
}))
